(() => {
  const STORAGE_KEY = 'prologoCompareProductsV1';

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const escapeHtml = (value = '') =>
    String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  const parseHandle = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch {
      return null;
    }
  };

  onReady(() => {
    /*
      IMPORTANT:
      Use ONE controller for the whole page.
      This avoids conflicts when Shopify renders/reorders sections and
      Custom Liquid independently.
    */
    const sections = [...document.querySelectorAll('[data-prologo-compare]')];
    if (!sections.length) {
      console.warn('Prologo Compare: controller section not found.');
      return;
    }

    const section = sections[0];
    const configNode = section.querySelector('[data-prologo-compare-config]');

    let config = {
      fields: [],
      hideEmptyRows: true,
      featureHeading: 'Caratteristica',
      removeLabel: 'Rimuovi',
      replaceMessage: 'Puoi confrontare massimo [max] prodotti. Vuoi sostituire il primo prodotto selezionato?'
    };

    if (configNode) {
      try {
        config = { ...config, ...JSON.parse(configNode.textContent) };
      } catch (error) {
        console.warn('Prologo Compare: config JSON non valido.', error);
      }
    }

    const maxProducts = Number(section.dataset.maxProducts || config.maxProducts || 3);
    const minProducts = Number(section.dataset.minProducts || config.minProducts || 2);
    const compareLabel = section.dataset.compareLabel || 'Confronta';
    const selectedLabel = section.dataset.selectedLabel || 'Selezionato';
    const autoInject = section.dataset.autoInject === 'true';
    const autoInjectProduct = section.dataset.autoInjectProduct === 'true';
    const templateType = section.dataset.templateType || '';
    const currentProductHandle = section.dataset.currentProductHandle || '';

    const products = new Map();

    const readProductData = () => {
      document.querySelectorAll('[data-prologo-compare-product]').forEach((node) => {
        const handleAttr = node.dataset.prologoCompareProduct || '';

        try {
          const item = JSON.parse(node.textContent);
          if (item && item.handle) {
            products.set(item.handle, item);
          }
        } catch (error) {
          console.warn(
            `Prologo Compare: dati prodotto non validi${handleAttr ? ` (${handleAttr})` : ''}.`,
            error
          );
        }
      });
    };

    readProductData();

    const bar = section.querySelector('[data-compare-bar]');
    const selectedWrap = section.querySelector('[data-compare-selected]');
    const openButton = section.querySelector('[data-compare-open]');
    const clearButton = section.querySelector('[data-compare-clear]');
    const counter = section.querySelector('[data-compare-counter]');
    const modal = section.querySelector('[data-compare-modal]');
    const tableWrap = section.querySelector('[data-compare-table]');

    if (!bar || !selectedWrap || !openButton || !counter || !modal || !tableWrap) {
      console.warn('Prologo Compare: markup controller incompleto.');
      return;
    }

    let selected = [];

    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (Array.isArray(stored)) selected = stored.slice(0, maxProducts);
    } catch {
      selected = [];
    }

    const save = () => {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(selected));
      } catch (error) {
        console.warn('Prologo Compare: impossibile salvare la selezione.', error);
      }
    };

    const selectedIndex = (handle) =>
      selected.findIndex((item) => item.handle === handle);

    const fallbackProductFromButton = (button) => {
      const handle = button.dataset.productHandle || '';
      if (!handle) return null;

      return {
        handle,
        title: button.dataset.productTitle || handle,
        url: button.dataset.productUrl || `/products/${encodeURIComponent(handle)}`,
        price: button.dataset.productPrice || '',
        available: true,
        image: button.dataset.productImage || '',
        fields: {}
      };
    };

    const productForButton = (button) => {
      const handle = button.dataset.productHandle || '';
      return products.get(handle) || fallbackProductFromButton(button);
    };

    const refreshButtons = () => {
      document.querySelectorAll('[data-prologo-compare-trigger]').forEach((button) => {
        const handle = button.dataset.productHandle || '';
        const active = handle && selectedIndex(handle) >= 0;

        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');

        const label = button.querySelector('.prologo-compare-trigger__label');
        if (label) label.textContent = active ? selectedLabel : compareLabel;
      });
    };

    const renderBar = () => {
      if (!selected.length) {
        bar.hidden = true;
        selectedWrap.innerHTML = '';
        counter.textContent = `0/${maxProducts}`;
        openButton.disabled = true;
        return;
      }

      bar.hidden = false;

      selectedWrap.innerHTML = selected.map((item) => `
        <div class="prologo-compare__selected-item">
          ${item.image
            ? `<img class="prologo-compare__selected-image" src="${escapeHtml(item.image)}" alt="">`
            : '<span></span>'
          }
          <span class="prologo-compare__selected-title">${escapeHtml(item.title)}</span>
          <button
            type="button"
            class="prologo-compare__remove"
            aria-label="${escapeHtml(config.removeLabel || 'Rimuovi')} ${escapeHtml(item.title)}"
            data-compare-remove="${escapeHtml(item.handle)}"
          >×</button>
        </div>
      `).join('');

      counter.textContent = `${selected.length}/${maxProducts}`;
      openButton.disabled = selected.length < minProducts;
    };

    const renderTable = () => {
      const fields = Array.isArray(config.fields) ? config.fields : [];

      const productHeaders = selected.map((item) => `
        <th class="prologo-compare__product-head">
          ${item.image
            ? `<img class="prologo-compare__product-image" src="${escapeHtml(item.image)}" alt="">`
            : ''
          }
          <a class="prologo-compare__product-title" href="${escapeHtml(item.url)}">
            ${escapeHtml(item.title)}
          </a>
          <span class="prologo-compare__product-price">${escapeHtml(item.price || '')}</span>
        </th>
      `).join('');

      const rows = fields.map((field) => {
        const fieldKey = `${field.namespace}.${field.key}`;

        const values = selected.map((item) =>
          item.fields?.[fieldKey] || { value: '', visuals: [] }
        );

        if (
          config.hideEmptyRows &&
          values.every((entry) => !entry.value && !(entry.visuals || []).length)
        ) {
          return '';
        }

        const cells = values.map((entry) => {
          const visuals = Array.isArray(entry.visuals) ? entry.visuals : [];

          const visualHtml = visuals.length
            ? `<div class="prologo-compare__visuals">
                ${visuals.map((src) => `<img src="${escapeHtml(src)}" alt="">`).join('')}
               </div>`
            : '';

          const value = entry.value
            ? escapeHtml(entry.value).replace(/\n/g, '<br>')
            : '<span class="prologo-compare__empty">—</span>';

          return `<td class="prologo-compare__cell">${visualHtml}${value}</td>`;
        }).join('');

        return `
          <tr>
            <th class="prologo-compare__feature-col">${escapeHtml(field.label || '')}</th>
            ${cells}
          </tr>
        `;
      }).join('');

      tableWrap.innerHTML = `
        <table class="prologo-compare__table">
          <thead>
            <tr>
              <th class="prologo-compare__feature-col">
                ${escapeHtml(config.featureHeading || 'Caratteristica')}
              </th>
              ${productHeaders}
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      `;
    };

    const update = () => {
      save();
      renderBar();
      refreshButtons();
    };

    const toggleProduct = (product) => {
      if (!product || !product.handle) return;

      const index = selectedIndex(product.handle);

      if (index >= 0) {
        selected.splice(index, 1);
        update();
        return;
      }

      if (selected.length >= maxProducts) {
        const message = String(config.replaceMessage || '')
          .replace('[max]', maxProducts);

        if (!window.confirm(message)) return;
        selected.shift();
      }

      /*
        Prefer the full hidden JSON record when available, because it
        contains all configured metafields. The button dataset is fallback.
      */
      selected.push(products.get(product.handle) || product);
      update();
    };

    /*
      CAPTURE PHASE:
      Pipeline/product-form handlers cannot stop this event before us.
      No per-button binding is needed, so Custom Liquid may render before
      or after the Compare section.
    */
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('[data-prologo-compare-trigger]');

      if (trigger) {
        event.preventDefault();
        event.stopImmediatePropagation();

        readProductData();

        const product = productForButton(trigger);

        if (!product) {
          console.warn('Prologo Compare: prodotto non trovato per il pulsante.', trigger);
          return;
        }

        toggleProduct(product);
        return;
      }

      const remove = event.target.closest?.('[data-compare-remove]');

      if (remove) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const handle = remove.dataset.compareRemove || '';
        const index = selectedIndex(handle);

        if (index >= 0) {
          selected.splice(index, 1);
          update();
        }
      }
    }, true);

    clearButton?.addEventListener('click', (event) => {
      event.preventDefault();
      selected = [];
      update();
    });

    openButton?.addEventListener('click', (event) => {
      event.preventDefault();

      if (selected.length < minProducts) return;

      renderTable();
      modal.hidden = false;
      document.body.classList.add('prologo-compare-is-open');
    });

    section.querySelectorAll('[data-compare-close]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        modal.hidden = true;
        document.body.classList.remove('prologo-compare-is-open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        modal.hidden = true;
        document.body.classList.remove('prologo-compare-is-open');
      }
    });

    const injectButton = (card, handle) => {
      if (!card || !handle) return;

      if (
        card.querySelector(
          `[data-prologo-compare-trigger][data-product-handle="${CSS.escape(handle)}"]`
        )
      ) return;

      const product = products.get(handle);
      if (!product) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'prologo-compare-trigger';
      button.dataset.prologoCompareTrigger = '';
      button.dataset.productHandle = handle;
      button.dataset.productTitle = product.title || '';
      button.dataset.productUrl = product.url || '';
      button.dataset.productPrice = product.price || '';
      button.dataset.productImage = product.image || '';

      button.innerHTML = `
        <span class="prologo-compare-trigger__box" aria-hidden="true"></span>
        <span class="prologo-compare-trigger__label">${escapeHtml(compareLabel)}</span>
      `;

      const insertSelector = (section.dataset.insertSelector || '').trim();
      let target = null;

      if (insertSelector) {
        try {
          target = card.querySelector(insertSelector);
        } catch {}
      }

      (target || card).append(button);
    };

    const autoInjectCollectionButtons = () => {
      if (templateType !== 'collection' || !autoInject) return;

      readProductData();

      const main = document.querySelector('main, #MainContent, [role="main"]') || document;
      const cardSelector = (section.dataset.cardSelector || '').trim();

      main.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        /* Never inject Compare buttons inside the Compare UI itself. */
        if (link.closest('[data-prologo-compare], [data-compare-modal], .prologo-compare__modal, .prologo-compare__bar')) {
          return;
        }

        const handle = parseHandle(link.href);
        if (!handle || !products.has(handle)) return;

        let card = null;

        if (cardSelector) {
          try {
            card = link.closest(cardSelector);
          } catch {}
        }

        if (!card) {
          let node = link.parentElement;

          for (let level = 0; node && level < 5; level += 1, node = node.parentElement) {
            if (node.querySelector('img')) {
              card = node;
              break;
            }
          }
        }

        if (!card || !card.querySelector('img')) return;
        injectButton(card, handle);
      });
    };

    const autoInjectProductButton = () => {
      if (
        templateType !== 'product' ||
        !autoInjectProduct ||
        !currentProductHandle
      ) return;

      readProductData();

      if (
        document.querySelector(
          `[data-prologo-compare-trigger][data-product-handle="${CSS.escape(currentProductHandle)}"]`
        )
      ) return;

      const selector = (section.dataset.productInsertSelector || '').trim();
      if (!selector) return;

      let target = null;

      try {
        target = document.querySelector(selector);
      } catch {}

      if (!target) return;

      const product = products.get(currentProductHandle);
      if (!product) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'prologo-compare-trigger prologo-compare-trigger--product';
      button.dataset.prologoCompareTrigger = '';
      button.dataset.productHandle = product.handle;
      button.dataset.productTitle = product.title || '';
      button.dataset.productUrl = product.url || '';
      button.dataset.productPrice = product.price || '';
      button.dataset.productImage = product.image || '';

      button.innerHTML = `
        <span class="prologo-compare-trigger__box" aria-hidden="true"></span>
        <span class="prologo-compare-trigger__label">${escapeHtml(compareLabel)}</span>
      `;

      target.insertAdjacentElement('beforebegin', button);
    };

    autoInjectCollectionButtons();
    autoInjectProductButton();
    update();

    let scheduled = false;

    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        readProductData();
        autoInjectCollectionButtons();
        autoInjectProductButton();
        refreshButtons();
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.PrologoCompare = {
      toggleByHandle(handle) {
        readProductData();
        const product = products.get(handle);
        if (product) toggleProduct(product);
      },
      refresh() {
        readProductData();
        update();
      },
      getSelected() {
        return [...selected];
      }
    };
  });
})();